<template>
  <div class="ListAcceptTerm">
    <HeaderPage>

    </HeaderPage>
    <el-card v-loading="loadingPage">
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="id" label="#" width="80">
        </el-table-column>
        <el-table-column prop="name" label="Nome">
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog(scope.row.id)">
              <EditIcon size="1.2x" style="padding: 0 7px;"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
    <dialogEditAddAcceptTerm :show="dialogEditAdd" :idTerm="idTerm" @close="closeDialog" />
  </div>
</template>
<script>

import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import { getAcceptTerms } from "@/app/domains/Config/services";
import {EditIcon} from "vue-feather-icons";
import dialogEditAddAcceptTerm from "@/app/domains/Config/components/AcceptTerm/dialogEditAddAcceptTerm";
export default {
  name: "ListAcceptTerm",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    dialogEditAddAcceptTerm,
  },
  data () {
    return {
      dialogEditAdd: false,
      loadingPage: true,
      idTerm: '',
      listData: {},
      ruleForm: {
        searchInput: ''
      },
    }
  },
  methods: {
    init () {
      this.ListAcceptTerm()
    },
    closeDialog() {
      this.idTerm = ''
      this.dialogEditAdd = false
      this.init()
    },
    openDialog (id) {
      this.dialogEditAdd = true
      this.idTerm = id
    },
    paginationClick (arg) {
      this.ListAcceptTerm('?page='+arg.page)
    },
    async ListAcceptTerm (query = '') {
      let res = await getAcceptTerms();
      this.listData = res.data
      this.modalVisible = true
      this.loadingPage = false
    },

  },
  mounted() {
    this.init()
  }
}
</script>
<style scoped>
</style>